<template>
    <base-layout>
        <!-- 组件 -->
        <site-header/>
        <video-player ref="player"/>
        <light-box ref="lightbox"/>
        <!-- 顶部 -->
        <div class="section section-a">
            <div class="container">
                <!-- 播放视频按钮 -->
                <div class="plau-vedio">
                    <button class="btn btn-play" @click="play"></button>
                </div>
                <br>
                <!-- <img class="prheat-btn" src="@/assets/img/prheat-btn.png" > -->
                <!--<div class="prheat-btn"></div> -->
            </div>
        </div>
        <div class="section section-b">
            <div class="container">
                <!-- 轮播图 -->
                <div id="carousel" class="groud">
                    <div class="swiper-container" ref="carousel">
                        <div class="swiper-wrapper">
                            <a
                                v-for="(item, idx) in pics"
                                :key="idx"
                                :href="item.url"
                                class="swiper-slide">
                                <img :src="item.path">
                            </a>
                        </div>
                    </div>
                    <div :class="['carousel-pagination', `carousel-pagination-${pics.length}`]"></div>
                </div>
                <!-- 首页资讯 -->
                <div id="news-list" class="groud">
                    <div class="top" v-if="topNews.id">
                        <a :title="topNews.title" :href="`./article.html?id=${topNews.id}`">{{ topNews.title }}</a>
                    </div>
                    <news-list :isIndex="true"></news-list>
                </div>
                <!-- 下载 -->
                <div v-if="!arraign" id="download" class="pull-left">
                    <div class="qrcode">
                        <img src="../assets/img/qrcode.png">
                        {{ $t('qrcode_tips') }}
                    </div>
                    <download-btn/>
                </div>
            </div>
        </div>
        <div class="section section-c">
            <div class="container">
                <div class="game-data">
                    <a href="./news.html?tab=5" class="item"><img src="../assets/img/class.png" :alt="$t('level5')"></a>
                    <a href="./news.html?tab=6" class="item"><img src="../assets/img/new.png" :alt="$t('level6')"></a>
                    <a href="./news.html?tab=7" class="item"><img src="../assets/img/master.png" :alt="$t('level7')"></a>
                    <a href="./news.html?tab=8" class="item"><img src="../assets/img/system.png" :alt="$t('level8')"></a>
                </div>
            </div>
        </div>
        <div class="section section-d">
            <div class="container">
                <div class="section-title">
                    <!-- <i class="iconfont icon-img"></i> {{ $t('album') }} -->
                    <img src="../assets/img/slogan.png">
                </div>
                <ul class="screenshot">
                    <!-- <div class="swiper-container" ref="screenshot">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide"><img src="../assets/img/ss1.jpg"></div>
                            <div class="swiper-slide"><img src="../assets/img/ss2.jpg"></div>
                            <div class="swiper-slide"><img src="../assets/img/ss3.jpg"></div>
                            <div class="swiper-slide"><img src="../assets/img/ss3.jpg"></div>
                            <div class="swiper-slide"><img src="../assets/img/ss3.jpg"></div>
                        </div>
                    </div> -->
                    <!-- <div class="screenshot-pagination"></div> -->
                    <li class="screenItem"><img src="../assets/img/ss1.png" @click="handleImg"></li>
                    <li class="screenItem"><img src="../assets/img/ss2.png" @click="handleImg"></li>
                    <li class="screenItem"><img src="../assets/img/ss3.png" @click="handleImg"></li>
                    <li class="screenItem"><img src="../assets/img/ss4.png" @click="handleImg"></li>
                    <li class="screenItem"><img src="../assets/img/ss5.png" @click="handleImg"></li>
                </ul>
            </div>
        </div>
        <site-footer/>
    </base-layout>
</template>

<script>

import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'

export default {
    name: 'Index',
    data () {
        return {
            pics: [],
            topNews: {}
        }
    },
    components: {
        VideoPlayer: () => import('components/VideoPlayer'),
        SiteHeader: () => import('components/SiteHeader'),
        SiteFooter: () => import('components/SiteFooter'),
        NewsList: () => import('components/NewsList'),
        DownloadBtn: () => import('components/DownloadBtn'),
        LightBox: () => import('components/LightBox')
    },
    computed: {
        player () {
            return this.$refs.player
        },
        lightbox () {
            return this.$refs.lightbox
        }
    },
    methods: {
        play () {
            this.player.play(this.g.video)
        },
        preview (url) {
            this.lightbox.show(url)
        },
        handleImg (e){
            let img = e.target || e.srcElement
            if(img.nodeName === 'IMG') {
                this.preview(img.src)
            }
        }
    },
    beforeMount () {
        // 轮播图
        $.get($.path.getArticleList, {
            gameid: this.g.gameid,
            ispic: 1,
            count: 6
        }).then(({data}) => {
            this.pics = data
            // init pics
            this.$nextTick(() => {
                // 轮播图
                new Swiper(this.$refs.carousel, {
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    grabCursor : true,
                    pagination: {
                        el: '.carousel-pagination',
                        clickable :true
                    },
                    uniqueNavElements: false,
                    loop : true,
                    mousewheel: true
                })
            })
        })

        // 头条
        $.get($.path.getArticleList, {
            gameid: this.g.gameid,
            istop: 1
        }).then(({data}) => {
            this.topNews = data[0]
        })
    },
    mounted () {
        // new Swiper(this.$refs.screenshot, {
        //     autoplay: {
        //         delay: 3000,
        //         stopOnLastSlide: false,
        //         disableOnInteraction: true
        //     },
        //     slidesPerView : 3,
        //     slidesPerGroup : 3,
        //     spaceBetween : 20,
        //     grabCursor : true,
        //     pagination: {
        //         el: '.screenshot-pagination',
        //         clickable :true
        //     },
        //     uniqueNavElements: false,
        //     loop : true,
        //     mousewheel: true,
        //     on: {
        //         tap: ev => {
        //             let img = ev.target || ev.srcElement
        //             if(img.nodeName === 'IMG') {
        //                 this.preview(img.src)
        //             }
        //         }
        //     }
        // })
    }
}
</script>

<style lang="scss" src="~/scss/index.scss"></style>